import { createStore } from 'redux';
import { SummaryType } from './seomapitype';
import moment from 'moment';

const initialState = {
  isSiteListLoading: true,
  sidebarShow: 'responsive',
  sitesData: [],
  //mainSeriesData: [],
  siteMainSeriesData: {},
  measurementSeriesData: [],
  // siteMeasurementData: [],
  announcements: [],
  selectedSiteId: '',
  selectedDeviceId: '',

  chartUnitSelection: SummaryType.DAY,
  chartTargetTimestamp: moment().startOf('day').unix(),
  chartLegendCollapsedChanged: false,
  chartConnectNulls: false,
  searchMVColumnFilter: {
    site_name: '',
    device_name: '',
    device_type: '',
  },
  cognitoUser: null,
  loading: false,
  nonFossil: {
    self_sufficiency_rate: 0,
    energy_cost_saving: 0,
    co2_reduction: 0,
  },
};

const changeState = (state = initialState, { type, ...rest }) => {
  switch (type) {
    case 'set':
      return { ...state, ...rest };
    case 'clear':
      return initialState;
    default:
      return state;
  }
};

const store = createStore(changeState);
export default store;
